import { render } from "./aDebentureDetails.vue?vue&type=template&id=11bbb6a3&ts=true"
import script from "./aDebentureDetails.vue?vue&type=script&lang=ts"
export * from "./aDebentureDetails.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__